

export const aiToolTemplate = {
    backToWorkbench: '返回工作臺',
    uploadImage: '上傳圖片',
    uploadImageDescription: '支援 JPG、PNG 格式，最大 10MB',
    clickOrDragUpload: '點擊或拖拽上傳圖片',
    uploadSuggestion: '建議使用清晰的圖片以獲得最佳效果',
    
    // 文生图相关
    enterPrompt: '輸入提示詞',
    enterPromptDescription: '請輸入描述您想要生成圖片的提示詞',
    promptPlaceholder: '請輸入您想要生成的圖片描述...',
    enterPromptFirst: '請先輸入提示詞',

    supplementaryPrompt: '補充提示詞',
    supplementaryPromptDescription: '添加額外的描述來微調生成結果（可選）',
    enterSupplementaryPrompt: '請輸入補充提示詞...',
    
    generationResult: '生成結果',
    resultCompleted: '您的{toolName}已生成完成',
    resultWaiting: '上傳圖片並點擊生成按鈕開始創作',
    waitingGeneration: '等待生成',
    waitingDescription: '上傳圖片後，生成的{toolName}將在這裡顯示',
    startGeneration: '開始生成',
    generating: '生成中',
    downloadImage: '下載圖片',
    downloadAllImages: '下載所有圖片',
    downloadStarted: '開始下載圖片',
    downloadFailed: '下載失敗，請稍後重試',
    generationFailed: '生成失敗，請稍後重試',
    // 新增的硬编码文本翻译
    uploadImageFirst: '請先上傳一張圖片',
    generationStarted: '圖片生成已開始，請稍候...',
    generationSuccess: '圖片生成成功！',
    promptRequired: '請輸入提示詞',
    generationTimeout: '生成超時，請稍後重試',
    generationStatusError: '生成狀態異常',
    pollStatusFailed: '查詢生成狀態失敗',
    generationStatusAbnormal: '生成狀態異常',
    
    // SizeSelector component translations
    generationSettings: '生成設置',
    model: '模型',
    aspectRatio: '圖片比例',
    resolution: '解析度',
    // PromptInput 组件翻译
    promptInput: {
      defaultTitle: '輸入提示詞',
      defaultPlaceholder: '請輸入您的提示詞...',
      validation: {
        required: '此欄位為必填項',
        minLength: '至少需要 {min} 個字符',
        maxLength: '不能超過 {max} 個字符',
        pattern: '輸入格式不正確'
      },
      suggestions: {
        toggle: '查看提示詞建議',
        title: '提示詞建議'
      }
    },
    
    // ImageUpload 组件翻译
    imageUpload: {
      defaultTitle: '上傳圖片',
      defaultDescription: '支援 JPG、PNG、GIF 格式，最大 10MB',
      referenceTitle: '上傳參考圖片',
      referenceDescription: '上傳一張參考圖片來指導Logo設計風格',
      referencePlaceholder: '點擊上傳參考圖片',
      dragDropText: '拖拽圖片到此處，或',
      clickToUpload: '點擊上傳',
      uploading: '上傳中...',
      addMore: '添加更多圖片',
      removeImage: '移除圖片',
      validation: {
        required: '請上傳至少一張圖片',
        fileSize: '檔案大小不能超過 {maxSize}MB',
        fileType: '不支援的檔案格式，請上傳 {allowedTypes}',
        maxFiles: '最多只能上傳 {max} 張圖片',
        uploadFailed: '上傳失敗，請重試'
      }
    },
    
    // ColorPicker 组件翻译
    colorPicker: {
      defaultTitle: '選擇顏色',
      defaultDescription: '選擇背景顏色或輸入自定義顏色值',
      currentColor: '當前顏色',
      noColorSelected: '未選擇顏色',
      showPalette: '顯示調色板',
      hidePalette: '隱藏調色板',
      presetColors: '預設顏色',
      customColor: '自定義顏色',
      colorInput: '顏色值',
      clearColor: '清除顏色',
      selectedColor: '選中顏色',
      none: '無',
      hexPlaceholder: '輸入十六進制顏色值',
      validation: {
        required: '請選擇一個顏色',
        invalidFormat: '無效的顏色格式，請使用 #RRGGBB 格式'
      }
    },

    placePicker: {
      validation: {
        required: '請選擇一個位置'
      }
    },
    
    // 错误消息
    fileTooLarge: '檔案大小不能超過 10MB',
    invalidFileType: '請上傳 JPG、PNG 或 GIF 格式的圖片',
    uploadFailed: '上傳失敗，請重試',
    networkError: '網路錯誤，請檢查網路連接',
    serverError: '伺服器錯誤，請稍後重試',
    // 工具名稱和描述
    tools: {
      watercolor: {
        name: '水彩畫風格',
        description: '將您的圖片轉換為柔和透明的水彩畫藝術效果，營造夢幻浪漫的視覺體驗'
      },
      sketch: {
        name: '素描風格',
        description: '將您的圖片轉換為精緻的素描藝術作品，展現線條的力量與美感'
      },
      cyberpunk: {
        name: '賽博朋克風格',
        description: '將您的圖片轉換為未來科技感的賽博朋克藝術風格，營造炫酷的科幻氛圍'
      },
      popArt: {
        name: '波普藝術肖像',
        description: '將您的肖像轉換為鮮豔大膽的波普藝術風格，展現現代藝術的魅力'
      },
      anime: {
        name: '動漫風格轉換',
        description: '將您的圖片轉換為精美的動漫風格，體驗二次元的魅力世界'
      },
      faceSwap: {
        name: 'AI 捏臉',
        description: '上傳一張包含人臉的圖片，即可生成不同風格的頭像'
      },
      oilPainting: {
        name: '油畫風格',
        description: '將您的圖片轉換為經典的油畫藝術作品，展現傳統繪畫的厚重質感'
      },
      professionalPortrait: {
        name: '職業肖像照',
        description: '生成專業的商務頭像',
        clothingStyle: '服裝風格',
        clothingStyleDesc: '選擇肖像照的職業服裝',
        styles: {
          default: '預設 (深色西裝)',
          darkSuit: '深色西裝',
          lightSuit: '淺色西裝',
          shirt: '商務襯衫',
          casual: '商務休閒',
          tuxedo: '燕尾服/禮服',
          polo: 'Polo衫',
          dress: '職業連身裙',
          blazer: '西裝外套+T恤'
        }
      },
      idPhotoGeneration: {
        name: '證件照生成',
        description: '將您的照片轉換為標準的證件照，支援多種尺寸和背景顏色'
      },
      photoRestoration: {
        name: '老照片修復',
        description: '修復老舊、損壞或褪色的照片，去除劃痕、污漬和瑕疵，恢復照片原有的清晰度和色彩',
        uploadTitle: '上傳老照片',
        uploadDescription: '支援 JPG、PNG、GIF 格式，最大 10MB',
        uploadPlaceholder: '點擊或拖拽上傳需要修復的老照片'
      },
      emojiPack: {
        name: '表情包製作',
        description: '上傳一張圖片，智慧生成一整套風格統一的表情包，涵蓋多種表情與動作，適合聊天與社群平台使用'
      }
    }
  };
